import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { inputCls, ghostBtn } from '../ui';
import { KIND } from './SubjectResult';

const EMPTY = { name: '', kind: 'person', code: '', birth_date: '' };
const CF_RE = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;
const OMO = 'LMNPQRSTUV';
const num = (s) => Number(s.replace(/[LMNPQRSTUV]/g, (c) => OMO.indexOf(c)));

export function birthFromCf(code) {
  const cf = (code || '').trim().toUpperCase();
  if (!CF_RE.test(cf)) return '';
  const yy = num(cf.slice(6, 8)); const day = num(cf.slice(9, 11)) % 40; const month = 'ABCDEHLMPRST'.indexOf(cf[8]) + 1;
  const year = 2000 + yy <= new Date().getFullYear() ? 2000 + yy : 1900 + yy;
  const d = new Date(Date.UTC(year, month - 1, day));
  if (d.getUTCDate() !== day) return '';
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export default function SubjectForm({ subjects, setSubjects }) {
  const [f, setF] = useState(EMPTY);
  const [auto, setAuto] = useState(false);
  const setCode = (code) => {
    const b = f.kind === 'person' && (!f.birth_date || auto) ? birthFromCf(code) : '';
    if (b) { setF({ ...f, code, birth_date: b }); setAuto(true); return; }
    setF({ ...f, code, birth_date: auto ? '' : f.birth_date });
    setAuto(false);
  };
  const add = () => {
    if (f.name.trim().length < 2) return;
    setSubjects([...subjects, { ...f, name: f.name.trim().toUpperCase(), code: f.code.trim().toUpperCase() || null, birth_date: f.birth_date || null }]);
    setF(EMPTY); setAuto(false);
  };
  return (
    <div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr_auto] gap-3">
        <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Cognome Nome o ragione sociale" className={inputCls} data-testid="aml-input-name" onKeyDown={(e) => e.key === 'Enter' && add()} />
        <select value={f.kind} onChange={(e) => { const kind = e.target.value; const b = kind === 'person' && (!f.birth_date || auto) ? birthFromCf(f.code) : ''; setF({ ...f, kind, birth_date: b || (auto || kind !== 'person' ? '' : f.birth_date) }); setAuto(!!b); }} className={`${inputCls} px-3 border`} data-testid="aml-input-kind">
          <option value="person">Persona fisica</option><option value="company">Persona giuridica</option>
        </select>
        <Input value={f.code} onChange={(e) => setCode(e.target.value)} placeholder="Codice fiscale / P.IVA" className={inputCls} data-testid="aml-input-code" />
        <Input type="date" value={f.birth_date} disabled={f.kind !== 'person'} onChange={(e) => { setF({ ...f, birth_date: e.target.value }); setAuto(false); }} title={auto ? 'Data ricavata dal codice fiscale' : undefined} className={inputCls} data-testid="aml-input-birth" />
        <button onClick={add} className={`${ghostBtn} h-11 px-4 flex items-center gap-2 text-sm`} data-testid="aml-add-subject"><Plus size={15} />Aggiungi</button>
      </div>
      {subjects.length > 0 && (
        <div className="mt-4 divide-y divide-[#1F242C] border border-[#1F242C]" data-testid="aml-subject-list">
          {subjects.map((s, i) => (
            <div key={i} className="px-4 py-3 flex items-center gap-3 text-sm">
              <span className="flex-1 min-w-0 truncate">{s.name} <span className="text-xs font-mono text-[#5A5F67]">{[KIND[s.kind], s.code, s.birth_date, s.role].filter(Boolean).join(' · ')}</span></span>
              <button onClick={() => setSubjects(subjects.filter((_, j) => j !== i))} className="text-[#5A5F67] hover:text-[#E37A72]" data-testid={`aml-remove-subject-${i}`}><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
